import { render } from "./SponsorPage.vue?vue&type=template&id=4ea16022&scoped=true"
import script from "./SponsorPage.vue?vue&type=script&lang=js"
export * from "./SponsorPage.vue?vue&type=script&lang=js"

import "./SponsorPage.vue?vue&type=style&index=0&id=4ea16022&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea16022"]])

export default __exports__